var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministrateur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.75 13.0209C3.75 9.02384 3.75 7.02535 4.2219 6.35301C4.69379 5.68067 6.5729 5.03745 10.3311 3.75099L11.0471 3.5059C13.0063 2.8353 13.9858 2.5 15 2.5C16.0142 2.5 16.9938 2.8353 18.9529 3.5059L19.6689 3.75099C23.4271 5.03745 25.3062 5.68067 25.7781 6.35301C26.25 7.02535 26.25 9.02384 26.25 13.0209V14.9893C26.25 22.0367 20.9513 25.4569 17.6268 26.9091C16.725 27.303 16.2741 27.5 15 27.5C13.7259 27.5 13.275 27.303 12.3732 26.9091C9.0487 25.4569 3.75 22.0367 3.75 14.9893V13.0209Z",
    fill: "#A70606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.25C17.5 12.6307 16.3807 13.75 15 13.75C13.6193 13.75 12.5 12.6307 12.5 11.25C12.5 9.86929 13.6193 8.75 15 8.75C16.3807 8.75 17.5 9.86929 17.5 11.25Z",
    fill: "#A70606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.25C20 21.25 20 20.1307 20 18.75C20 17.3693 17.7614 16.25 15 16.25C12.2386 16.25 10 17.3693 10 18.75C10 20.1307 10 21.25 15 21.25Z",
    fill: "#A70606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrateur);
export default __webpack_public_path__ + "static/media/administrateur.ebb594bb68ec79406697fb02507aa224.svg";
export { ForwardRef as ReactComponent };